import { Component, input } from '@angular/core';

@Component({
  selector: 'app-add-wishlist-icon',
  imports: [],
  templateUrl: './add-wishlist-icon.html',
  styleUrl: './add-wishlist-icon.scss'
})
export class AddWishlistIcon {
  isFilled = input<boolean>(false);

}
